import React from "react"
import {
  Flex, Text, Tooltip, useBreakpointValue,
} from "@chakra-ui/react"
import Icon from "components/elements/Icon"

type Props = {
  icon: string
  text: string
  onClick: () => void
  color?: string
}

const ActionIcon = ({
  icon,
  text,
  onClick,
  color = "blue.400",
}: Props) => {
  const showLabel = useBreakpointValue({ base: false, xl: true })

  return (
    <Tooltip label={text} isDisabled={showLabel}>
      <Flex
        as="button"
        direction="row"
        align="center"
        color={color}
        onClick={onClick}
        type="button"
        mx={2}
        flexShrink={0}
        whiteSpace="nowrap"
        _hover={{ textDecoration: showLabel ? "underline" : "none", bg: showLabel ? undefined : "gray.100" }}
        {...(!showLabel && { p: 2, borderRadius: "md" })}
      >
        <Icon icon={icon} size={4} mr={showLabel ? 2 : 0} />
        {showLabel && (
          <Text fontSize="md" fontWeight="medium">
            {text}
          </Text>
        )}
      </Flex>
    </Tooltip>
  )
}

export default ActionIcon
